import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { salvarCredenciais } from '../../services/api';

export default function AdminCredenciais() {
  const { user } = useAuth();
  const [form, setForm] = useState({ nome: user?.nome || '', email: user?.email || '', senha_atual: '', nova_senha: '', confirmar: '' });
  const [loading, setLoading] = useState(false);
  const [mostrar, setMostrar] = useState(false);
  const [toast, setToast] = useState({ msg: '', erro: false });
  const showToast = (msg, erro = false) => { setToast({ msg, erro }); setTimeout(() => setToast({ msg: '', erro: false }), 3500); };

  const salvar = async () => {
    if (!form.senha_atual) return showToast('⚠️ Informe sua senha atual', true);
    if (form.nova_senha && form.nova_senha !== form.confirmar) return showToast('⚠️ Senhas não coincidem', true);
    if (form.nova_senha && form.nova_senha.length < 6) return showToast('⚠️ Mínimo 6 caracteres', true);
    setLoading(true);
    try {
      await salvarCredenciais({ nome: form.nome, email: form.email, senha_atual: form.senha_atual, nova_senha: form.nova_senha || undefined });
      showToast('✅ Credenciais atualizadas!');
      setForm(p => ({ ...p, senha_atual: '', nova_senha: '', confirmar: '' }));
    } catch (e) { showToast('❌ ' + (e.response?.data?.error || 'Erro'), true); }
    finally { setLoading(false); }
  };

  const forca = form.nova_senha.length === 0 ? 0 : form.nova_senha.length < 6 ? 1 : form.nova_senha.length < 10 ? 2 : 3;
  const forcaCor = ['var(--bg4)', 'var(--red)', 'var(--orange)', '#2ea82e'][forca];
  const forcaLabel = ['', 'Fraca', 'Média', 'Forte ✓'][forca];

  return (
    <div style={{ padding: 16 }}>
      {toast.msg && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: toast.erro ? 'linear-gradient(90deg,#c0392b,#e74c3c)' : 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999, whiteSpace: 'nowrap' }}>{toast.msg}</div>}

      <h2>🔐 Usuário e Senha</h2>

      {/* Card usuário */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, padding: 16, background: 'linear-gradient(135deg,#1a0000,#0a0a0a)', border: '1px solid #3a0000', borderRadius: 12, marginBottom: 16 }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'linear-gradient(135deg,var(--red),var(--orange))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18, color: '#fff', flexShrink: 0 }}>
          {(user?.nome || 'A')[0].toUpperCase()}
        </div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 15 }}>{user?.nome}</div>
          <div style={{ fontSize: 12, color: 'var(--text2)' }}>{user?.email}</div>
          <span style={{ background: 'var(--red)', color: '#fff', fontSize: 9, fontWeight: 800, padding: '2px 7px', borderRadius: 4, marginTop: 4, display: 'inline-block' }}>ADMINISTRADOR</span>
        </div>
      </div>

      {/* Dados */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>👤 Dados de Acesso</h3>
        <div className="input-group">
          <label className="input-label">Nome de exibição</label>
          <input className="input-field" value={form.nome} onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} placeholder="Seu nome" />
        </div>
        <div className="input-group">
          <label className="input-label">E-mail de login</label>
          <input className="input-field" type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} placeholder="seu@email.com" />
        </div>
      </div>

      {/* Senha */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h3>🔑 Alterar Senha</h3>
          <button onClick={() => setMostrar(p => !p)} style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text2)', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontFamily: 'Nunito,sans-serif' }}>{mostrar ? '🙈 Ocultar' : '👁️ Mostrar'}</button>
        </div>
        {[['Senha atual *', 'senha_atual', 'Senha atual'], ['Nova senha', 'nova_senha', 'Mínimo 6 caracteres'], form.nova_senha ? ['Confirmar nova senha', 'confirmar', 'Repita a nova senha'] : null].filter(Boolean).map(([label, field, placeholder]) => (
          <div className="input-group" key={field}>
            <label className="input-label">{label}</label>
            <input className="input-field" type={mostrar ? 'text' : 'password'} placeholder={placeholder}
              value={form[field]} onChange={e => setForm(p => ({ ...p, [field]: e.target.value }))}
              style={{ borderColor: field === 'confirmar' && form.confirmar && form.nova_senha !== form.confirmar ? 'var(--red)' : undefined }} />
          </div>
        ))}
        {form.nova_senha && (
          <div style={{ marginBottom: 8 }}>
            <div style={{ height: 6, background: 'var(--bg4)', borderRadius: 3, overflow: 'hidden', marginBottom: 4 }}>
              <div style={{ height: '100%', width: `${[0,33,66,100][forca]}%`, background: forcaCor, borderRadius: 3, transition: 'all .3s' }} />
            </div>
            <div style={{ fontSize: 10, color: forcaCor }}>{forcaLabel}</div>
          </div>
        )}
      </div>

      <div style={{ background: 'rgba(255,107,0,.08)', border: '1px solid rgba(255,107,0,.2)', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 12, color: 'var(--text2)', lineHeight: 1.6 }}>
        🔒 Use letras, números e símbolos. Nunca compartilhe sua senha.
      </div>

      <button className="btn-primary" onClick={salvar} disabled={loading}>
        {loading ? '⏳ Salvando...' : '💾 Salvar alterações'}
      </button>
    </div>
  );
}
